import { createAction, props } from "@ngrx/store";
import { ApiError } from "@hrra/core";
import { ApplicationViewModel, CvBoxApplicationViewModel } from "src/app/jobseeker/shared/services/jobseeker-applies.service";
import { ActionPayload } from "@hrra/core";
import { JobseekerInviteFilterEnum } from "src/app/jobseeker/shared/models/enums/invite-list-filter-enum";
import { JobseekerInviteListViewModel } from "src/app/jobseeker/shared/models/jobseeker-invite-model";
import { AnnouncementDetailsViewModel } from "src/app/announcement/shared/services/announcement.service";
import { AnnouncementInviteResponseEnum } from "@hrra/common-models";
import { AnnouncementDetails } from "src/app/announcement/shared/models/announcement-details-model";
import { AnnouncementViewRequestModel } from "src/app/announcement/shared/models/announcement-view-request.model";

export enum Actions{
    LoadApplications = '[Jobseeker applies] Load applications',
    LoadApplicationsSuccess = '[Jobseeker applies] Load applications success',
    LoadApplicationsFail = '[Jobseeker applies] Load applications fail',

    LoadCvBoxApplications = '[Jobseeker applies] Load cv box application',
    LoadCvBoxApplicationsSuccess = '[Jobseeker applies] Load cv box application success',
    LoadCvBoxApplicationsFail = '[Jobseeker applies] Load cv box application fail',

    LoadInvites = '[Jobseeker invites] Load invites',
    LoadInvitesSuccess = '[Jobseeker invites] Load invites success',
    LoadInvitesFail = '[Jobseeker invites] Load invites fail',

    LoadInviteAnnouncement = '[Jobseeker invites] Load invite announcement',
    LoadInviteAnnouncementSuccess = '[Jobseeker invites] Load invite announcement success',
    LoadInviteAnnouncementFail = '[Jobseeker invites] Load invite announcement fail',

    SendAnnouncementViewToAnalytics = '[Jobseeker invites] Send announcement to analytics',
    SendAnnouncementViewToAnalyticsSuccess = '[Jobseeker invites] Send announcement to analytic success',
    SendAnnouncementViewToAnalyticsFail = '[Jobseeker invites] Send announcement to analytic fail',

    ViewAnnouncement = '[Jobseeker invites] View announcement',
    ViewAnnouncementSuccess = '[Jobseeker invites] View announcement success',
    ViewAnnouncementFail = '[Jobseeker invites] View announcement fail',

    MarkInviteViewed = '[Jobseeker invites] Mark invite viewed',
    MarkInviteViewedSuccess = '[Jobseeker invites] Mark invite viewed success',
    MarkInviteViewedFail = '[Jobseeker invites] Mark invite viewed fail',

    RespondToInvite = '[Jobseeker invites] Respond to invite',
    RespondToInviteSuccess = '[Jobseeker invites] Respond to invite success',
    RespondToInviteFail = '[Jobseeker invites] Respond to invite fail',

    ResetPage = '[Jobseeker applies] Reset page',
}

export const loadApplications = createAction(
    Actions.LoadApplications,
    props<ActionPayload<{page: number}>>()
);
export const loadApplicationsSuccess = createAction(
    Actions.LoadApplicationsSuccess,
    props<ActionPayload<{application: ApplicationViewModel, page: number}>>()
);
export const loadApplicationsFail = createAction(
    Actions.LoadApplicationsFail,
    props<ActionPayload<ApiError>>()
);

export const loadCvBoxApplications = createAction(
    Actions.LoadCvBoxApplications,
    props<ActionPayload<{page: number}>>()
);
export const loadCvBoxApplicationsSuccess = createAction(
    Actions.LoadCvBoxApplicationsSuccess,
    props<ActionPayload<{application: CvBoxApplicationViewModel, page: number}>>()
);
export const loadCvBoxApplicationsFail = createAction(
    Actions.LoadCvBoxApplicationsFail,
    props<ActionPayload<ApiError>>()
);

export const loadInvites = createAction(
    Actions.LoadInvites,
    props<ActionPayload<{page: number, filter: JobseekerInviteFilterEnum}>>()
);
export const loadInvitesSuccess = createAction(
    Actions.LoadInvitesSuccess,
    props<ActionPayload<{jobseekerInviteResponse: JobseekerInviteListViewModel, page: number}>>()
);
export const loadInvitesFail = createAction(
    Actions.LoadInvitesFail,
    props<ActionPayload<ApiError>>()
);

export const loadInviteAnnouncement = createAction(
    Actions.LoadInviteAnnouncement,
    props<ActionPayload<{announcementId: number}>>()
);
export const loadInviteAnnouncementSuccess = createAction(
    Actions.LoadInviteAnnouncementSuccess,
    props<ActionPayload<{announcementDetails: AnnouncementDetailsViewModel}>>()
);
export const loadInviteAnnouncementFail = createAction(
    Actions.LoadInviteAnnouncementFail,
    props<ActionPayload<ApiError>>()
);

export const sendAnnouncementViewToAnalytic = createAction(
    Actions.SendAnnouncementViewToAnalytics,
    props<ActionPayload<{announcement: AnnouncementDetails, providerWebsiteId: number}>>()
);
export const sendAnnouncementViewToAnalyticSuccess = createAction(
    Actions.SendAnnouncementViewToAnalyticsSuccess,
    props<ActionPayload<{announcementDetails: AnnouncementDetailsViewModel}>>()
);
export const sendAnnouncementViewToAnalyticFail = createAction(
    Actions.SendAnnouncementViewToAnalyticsFail,
    props<ActionPayload<ApiError>>()
);

export const viewAnnouncement = createAction(
    Actions.ViewAnnouncement,
    props<ActionPayload<AnnouncementViewRequestModel>>()
);
export const viewAnnouncementSuccess = createAction(
    Actions.ViewAnnouncementSuccess
);
export const viewAnnouncementFail = createAction(
    Actions.ViewAnnouncementFail,
    props<ActionPayload<ApiError>>()
);

export const markInviteViewed = createAction(
    Actions.MarkInviteViewed,
    props<ActionPayload<{inviteId: number}>>()
);
export const markInviteViewedSuccess = createAction(
    Actions.MarkInviteViewedSuccess,
    props<ActionPayload<{inviteId: number}>>()
);
export const markInviteViewedFail = createAction(
    Actions.MarkInviteViewedFail,
    props<ActionPayload<ApiError>>()
);

export const respondToInvite = createAction(
    Actions.RespondToInvite,
    props<ActionPayload<{inviteId: number, responseStatus: AnnouncementInviteResponseEnum}>>()
);
export const respondToInviteSuccess = createAction(
    Actions.RespondToInviteSuccess,
    props<ActionPayload<{inviteId: number, responseStatus: AnnouncementInviteResponseEnum}>>()
);
export const respondToInviteFail = createAction(
    Actions.RespondToInviteFail,
    props<ActionPayload<ApiError>>()
);
